module.exports = __webpack_public_path__ + "static/logo-5e33f5b485e99802dec0ecb1173bca17.png";